/* ═══════════════════════════════════════
   MOTION FIT STUDIO — motion.js
   ═══════════════════════════════════════ */

(function () {
  'use strict';

  /* ── CUSTOM CURSOR ── */
  var cur = document.getElementById('cur');
  var ring = document.getElementById('curRing');
  if (cur && ring && window.matchMedia('(pointer: fine)').matches) {
    document.addEventListener('mousemove', function (e) {
      cur.style.left = e.clientX + 'px';
      cur.style.top  = e.clientY + 'px';
      ring.style.left = e.clientX + 'px';
      ring.style.top  = e.clientY + 'px';
    });
    document.querySelectorAll('a, button, [data-waiver], .plan-row').forEach(function (el) {
      el.addEventListener('mouseenter', function () {
        cur.style.width = '16px'; cur.style.height = '16px';
        ring.style.width = '52px'; ring.style.height = '52px';
        ring.style.opacity = '0.85';
      });
      el.addEventListener('mouseleave', function () {
        cur.style.width = '10px'; cur.style.height = '10px';
        ring.style.width = '36px'; ring.style.height = '36px';
        ring.style.opacity = '0.45';
      });
    });
  }

  /* ── MOBILE NAV ── */
  var burger = document.getElementById('navBurger');
  var drawer = document.getElementById('navDrawer');
  if (burger && drawer) {
    burger.addEventListener('click', function () {
      var open = drawer.classList.toggle('open');
      burger.classList.toggle('open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    });
    drawer.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        drawer.classList.remove('open');
        burger.classList.remove('open');
        burger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    });
  }

  /* ── ACTIVE NAV LINK ── */
  var path = window.location.pathname;
  document.querySelectorAll('.nav-links a, .nav-drawer a').forEach(function (a) {
    if (a.getAttribute('href') === path) a.classList.add('active');
  });

  /* ── SCROLL REVEAL ── */
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.08 });
    document.querySelectorAll('.reveal').forEach(function (el) { obs.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('visible'); });
  }

  /* ── CLASS FILTER (clases page) ── */
  window.filterCat = function (type, btn) {
    document.querySelectorAll('.cat-filter').forEach(function (b) { b.classList.remove('active'); });
    btn.classList.add('active');
    document.querySelectorAll('.cat-card').forEach(function (c) {
      c.style.display = (type === 'all' || c.dataset.cat === type) ? '' : 'none';
    });
  };

  /* ── WAIVER MODAL ── */
  var _pendingUrl = '';

  window.openWaiver = function (label, url) {
    _pendingUrl = url;

    var lbl = document.getElementById('waiverLabel');
    if (lbl) lbl.textContent = label;

    ['wc1','wc2','wc3'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.checked = false;
    });

    var btnGo = document.getElementById('btnGo');
    if (btnGo) {
      btnGo.classList.remove('ready');
      btnGo.setAttribute('href', '#');
    }

    var modal = document.getElementById('waiverModal');
    if (modal) {
      modal.classList.add('open');
      document.body.style.overflow = 'hidden';
    }

    var firstTab = modal ? modal.querySelector('.modal-tab') : null;
    if (firstTab) switchTab('r', firstTab);
  };

  window.closeWaiver = function () {
    var m = document.getElementById('waiverModal');
    if (m) m.classList.remove('open');
    _pendingUrl = '';
    document.body.style.overflow = '';
  };

  window.switchTab = function (tab, btn) {
    var modal = document.getElementById('waiverModal');
    if (!modal) return;
    modal.querySelectorAll('.modal-tab').forEach(function (t) { t.classList.remove('active'); });
    modal.querySelectorAll('.waiver-content').forEach(function (c) { c.classList.remove('active'); });
    if (btn) btn.classList.add('active');
    var wt = document.getElementById('wt-' + tab);
    if (wt) wt.classList.add('active');
  };

  window.checkAll = function () {
    var ok = ['wc1','wc2','wc3'].every(function (id) {
      var el = document.getElementById(id);
      return el && el.checked;
    });
    var btn = document.getElementById('btnGo');
    if (!btn) return;
    btn.classList.toggle('ready', ok);
    btn.setAttribute('href', (ok && _pendingUrl) ? _pendingUrl : '#');
  };

  window.goCheckout = function () {
    var btn = document.getElementById('btnGo');
    if (!btn || !btn.classList.contains('ready') || !_pendingUrl) return false;
    var m = document.getElementById('waiverModal');
    if (m) m.classList.remove('open');
    document.body.style.overflow = '';
    return true;
  };

  var modalBg = document.getElementById('waiverModal');
  if (modalBg) {
    modalBg.addEventListener('click', function (e) {
      if (e.target === modalBg) closeWaiver();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (document.getElementById('waiverModal') &&
          document.getElementById('waiverModal').classList.contains('open')) {
        closeWaiver();
      }
    }
  });

})();
